import { IDevice } from './types';

export const deviceInitialState: IDevice = {
  imei: '',
  invoiceNumber: '',
  invoiceSeries: '',
  ean: '',
};
